/* eslint-disable react/require-default-props */
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import './styles.scss';
/**
 * VerticalTabs component for organizing content into vertical tabs
 *
 * @deprecated This component is deprecated and will be removed in a future release.
 * Please use the new TabView component from '@ui' with `vertical={true}` prop instead.
 *
 * Migration path:
 * - Import: `import { TabView } from '@ui';`
 * - Add prop: `vertical={true}`
 * - API is compatible - same props structure
 *
 * @see {@link frontend/ui/molecules/TabView/TabView.tsx}
 * @see {@link docs/ai-knowledge/frontend/component-deprecation-plan.md}
 */
function VerticalTabs({ tabs, defaultTabId, activeTabId: externalActiveTabId, onChange, className, children }) {
    // Use internal state if component is uncontrolled
    const [internalActiveTabId, setInternalActiveTabId] = useState(defaultTabId || (tabs.length > 0 ? tabs[0].id : ''));
    // Determine if component is controlled or uncontrolled
    const isControlled = externalActiveTabId !== undefined;
    const activeTabId = isControlled ? externalActiveTabId : internalActiveTabId;
    // Update internal state when defaultTabId changes
    useEffect(() => {
        if (defaultTabId && !isControlled) {
            setInternalActiveTabId(defaultTabId);
        }
    }, [defaultTabId, isControlled]);
    // Handle tab change
    const handleTabChange = (tabId, disabled) => {
        if (disabled)
            return;
        if (!isControlled) {
            setInternalActiveTabId(tabId);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(tabId);
    };
    // Find the active tab's content
    const activeTab = tabs.find((tab) => tab.id === activeTabId);
    // Function to render tab content
    const renderTabContent = () => {
        // If children are provided, render them
        if (children) {
            return children;
        }
        // If the active tab has content, render it
        if (activeTab === null || activeTab === void 0 ? void 0 : activeTab.content) {
            return activeTab.content;
        }
        // Otherwise, render nothing
        return null;
    };
    return (React.createElement("div", { className: classNames('vertical-tabs', className) },
        React.createElement("div", { className: "vertical-tabs__list", role: "tablist", "aria-orientation": "vertical" }, tabs.map((tab) => (React.createElement("button", { type: "button", key: tab.id, id: `tab-${tab.id}`, className: classNames('vertical-tabs__tab', {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'vertical-tabs__tab--active': tab.id === activeTabId,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'vertical-tabs__tab--disabled': tab.disabled
            }), role: "tab", "aria-selected": tab.id === activeTabId, "aria-controls": `tabpanel-${tab.id}`, "aria-disabled": tab.disabled, disabled: tab.disabled, title: tab.disabled ? tab.disabledTooltip : undefined, onClick: () => handleTabChange(tab.id, tab.disabled) },
            React.createElement("span", { className: "vertical-tabs__tab-label" }, tab.label),
            tab.count !== undefined && React.createElement("span", { className: "vertical-tabs__tab-count" }, tab.count))))),
        React.createElement("div", { className: "vertical-tabs__content" }, tabs.map((tab) => (React.createElement("div", { key: tab.id, id: `tabpanel-${tab.id}`, role: "tabpanel", "aria-labelledby": `tab-${tab.id}`, className: classNames('vertical-tabs__panel', {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'vertical-tabs__panel--active': tab.id === activeTabId
            }) }, tab.id === activeTabId && renderTabContent()))))));
}
export default VerticalTabs;
